@use "../../styles/variables" as *;
.mds-button.mds-button-size-md.details-btn {
  .cnc-icon-component {
    color: var(--interact-icon-weak-default);
  }

  border-radius: 8px;
  border: 1px solid var(--base-border-default);
  background: var(--control-bg-weak-default);
  box-shadow: var(--shadow-floating);
  color: var(--base-text-default);
  font-size: var(--typography-size-p3);
  font-style: var(--typography-p3-regular);
  font-weight: var(--typography-weight-semi-bold);
}
